import { render, staticRenderFns } from "./MergeUserDetails.vue?vue&type=template&id=443dfc3a&scoped=true&"
import script from "./MergeUserDetails.vue?vue&type=script&lang=js&"
export * from "./MergeUserDetails.vue?vue&type=script&lang=js&"
import style0 from "./MergeUserDetails.vue?vue&type=style&index=0&id=443dfc3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443dfc3a",
  null
  
)

export default component.exports